import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home.vue'),
  },
  // auth routes
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../views/auth/index.vue'),
    children: [
      {
        path: 'confirmsession',
        name: 'confirmsession',
        component: () => import('../views/auth/confirmsession.vue'),
        meta: {
          title: 'Verifying session',
        },
      },
    ],
  },
  // app routes
  {
    path: '/app',
    name: 'app',
    component: () => import('../views/app/index.vue'),
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '',
        name: 'app-home',
        // component: () => import('../views/app/home.vue'),
        meta: {
          title: 'Home',
        },
        redirect: { name: 'app-projects-list' },
      },
      // invitations
      {
        path: 'invitations/accept',
        name: 'app-invitations-accept',
        component: () => import('../views/app/projects/accept-invite.vue'),
        meta: {
          title: 'Accept Invitation',
        },
      },
      // projects
      {
        path: 'projects',
        name: 'app-projects',
        component: () => import('../views/app/projects/index.vue'),
        meta: {
          title: 'Projects',
          requiresAuth: true,
        },
        children: [
          {
            path: '',
            name: 'app-projects-list',
            component: () => import('../views/app/projects/list.vue'),
            meta: {
              title: 'Projects',
            },
          },
          {
            path: 'invite/accept',
            name: 'app-project-accept-invite',
            component: () => import('../views/app/projects/accept-invite.vue'),
            meta: {
              title: 'Accept Invitation',
            },
          },
          {
            path: ':id',
            name: 'app-project',
            component: () => import('../views/app/projects/project.vue'),
            meta: {
              title: 'Project',
            },
          },
        ],
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  // Set title
  if (to.meta.title) {
    document.title = `${String(to.meta.title)} | contextify`;
  }

  if (to.query.redirect && !to.path.startsWith('/auth')) {
    if (to.query.redirect === 'undefined') {
      next({ path: '/app' });
    }
    // redirect to the to path
    next(to.query.redirect as string);
    return;
  }

  next();
});

export default router;
